<template>
  <div
    :class="['rowList', getStyleRow()]"
    tabindex="0"
    ref="notifContainer"
    @click="goToPublication"
  >
    <div class="avatarWrapper">
      <v-avatar size="36">
        <img
          class="avatar-image"
          :src="secureUrlAvatar() || require('@/assets/img/user-default.png')"
        />
      </v-avatar>
      <img class="flagIcon" v-if="source.language_flag" :src="getFlag()" />
    </div>
    <div class="contentWrapper">
      <div class="descriptionWrapper">
        <b class="author" :style="styles">{{
          source.author || 'CHI Family App'
        }}</b>
        <span class="description" :style="styles">{{
          source.description
        }}</span>
      </div>
      <div>
        <div :class="['date', getStyleText()]" :style="styles">
          {{ toDate() }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { _ } from 'vue-underscore'
import { forceSSL } from '@/helper/helper'
import { dateTimeAgo } from '@/helper/Format'
import { convertEmToPixels } from '../../helper/helper'

export default {
  name: 'notification-list',
  props: {
    source: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters(['getPostsData', 'getNotifsRefs']),
    styles () {
      const result = convertEmToPixels(16)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    }
  },
  methods: {
    ...mapActions({
      readAction: 'SET_NOTIF_READ',
      getPostFromKey: 'LOAD_SINGLE_POST',
      addChangeToQueue: 'ADD_TO_QUEUE',
      getPublicationLike: 'HAS_LIKE_TRUE',
      existPostFromNotif: 'EXIST_PUBLICATION_SINGLE_POST'
    }),
    ...mapMutations({
      setCurrentPost: 'SET_CURRENT_POST'
    }),
    toDate () {
      // const notifDate = Format.FirestoreDateToMoment(this.source.published_at)
      const notifDate = this.source.published_at
      return dateTimeAgo(notifDate)
    },
    getFlag () {
      const flag = this.source.language_flag.toLowerCase()
      return require(`@/assets/img/flags/${flag}.png`)
    },
    getCurrentRefNotif () {
      return _.findWhere(this.getNotifsRefs, { docId: this.source.key }) || {}
    },
    getStyleRow () {
      return this.getCurrentRefNotif().read ? 'rowRead' : 'rowUnread'
    },
    getStyleText () {
      return this.getCurrentRefNotif().read ? 'textRead' : 'textUnread'
    },
    secureUrlAvatar () {
      return this.source.avatar_uri && forceSSL(this.source.avatar_uri)
    },
    goToPublication () {
      const postKey = this.source.postKey
      if (postKey) {
        this.existPostFromNotif(postKey).then(result => {
          result &&
            this.$router.push({
              name: 'SinglePostNotif',
              params: {
                postId: postKey,
                notifId: this.source.key,
                isNotif: true
              }
            })
        })
      }
      this.readAction(this.getCurrentRefNotif())
      this.addChangeToQueue({
        key: this.source.key,
        currentScreen: 'notifications',
        fieldsName: ['read']
      })
    }
    // next () {
    //   this.readAction(this.getCurrentRefNotif()).then(() => this.getStyleRow())
    // },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/notifications/index.vue